<template>
  <div class="p-movies__wrapper">
    <div class="b-movie-card__wrapper">
      <div class="b-movie-card__wrapper__img">
        <img :src="imgPoster" alt="" />
      </div>
      <div class="b-movie-card__wrapper__elements">
        <div v-if="movieUrl" class="b-movie-card__btn-area">
          <a :href="movieUrl" class="b-movie-card__wrapper__cta"></a>
        </div>
      </div>
    </div>

    <div class="b-movie-card__content">
      <ScreenTypes
        container-class="e-rooms--green"
        class="mb-4"
        :sphera="sphera"
        :dolby="dolby"
        :three-dimensions="threeDimensions"
        :imax="imax"
        :imax3d="imax3D" />
      <div
        v-if="dictionary.premier && due"
        class="e-label e-label--bg e-label--playing">
        <span>{{ dictionary.premier }}</span>
        {{ due }}
      </div>

      <div class="b-movie-card__translate-label">
        <div v-if="translated" class="e-label e-label--translated">
          {{ dictionary.translatable }}
        </div>
      </div>
      <div class="b-movie-card__content-holder">
        <div class="b-movie-card__title-holder">
          <div class="b-movie-card__title">
            {{ title }}
          </div>
          <div class="b-movie-card__subtitle">
            {{ subTitle }}
          </div>
        </div>
        <div
          v-if="description"
          class="b-movie-card__description"
          v-html="description"></div>
        <div class="b-movie-attr">
          <div v-if="pg" class="e-k">{{ pg }}</div>
          <div v-if="genres.length && genres[0]" class="movie-attr--movie">
            <span v-for="(genre, index) in genres" :key="index">
              {{ genre }}
            </span>
          </div>
          <div v-if="duration" class="movie-attr--time">
            <span>{{ duration }}</span>
          </div>
        </div>
      </div>

      <div v-if="movieId && showBookButton" class="b-movie-card__buttons-area">
        <button
          type="button"
          class="b-movie-card__cta-btn"
          @click="openBooking">
          <span>{{ (dictionary && dictionary.bookTickets) || 'Book' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import constants from '../../lib/constants'
import { computed, getCurrentInstance } from 'vue'
import bookingRedirect from '../../lib/bookingRedirect'
import ScreenTypes from '../components/Shared/ScreenTypes.vue'

const { redirectIntoBooking } = bookingRedirect()

const { configuration } =
  getCurrentInstance().appContext.config.globalProperties

const props = defineProps({
  image: { default: '', type: String },
  movieUrl: { default: '', type: String },
  movieId: { default: '', type: String },
  showBookButton: { default: true, type: Boolean },
  playingNow: { default: false, type: Boolean },
  translated: { default: false, type: Boolean },
  title: { default: '', type: String },
  subTitle: { default: '', type: String },
  description: { default: '', type: String },
  pg: { default: '', type: String },
  genres: {
    default: () => {
      return []
    },
    type: Array,
  },
  duration: { default: 0, type: Number },
  dictionary: {
    default: () => {
      return {}
    },
    type: Object,
  },
  dolby: { default: false, type: Boolean },
  sphera: { default: false, type: Boolean },
  threeDimensions: { default: false, type: Boolean },
  imax: { default: false, type: Boolean },
  imax3D: { default: false, type: Boolean },
  baseUrl: { default: '', type: String },
  cinemaId: { default: '', type: String },
})

const openBooking = () => {
  if (props.cinemaId) {
    redirectIntoBooking(configuration.baseUrl, props.movieId, props.cinemaId)
  } else {
    redirectIntoBooking(configuration.baseUrl, props.movieId)
  }
}
const imgPoster = computed(() => {
  return props.image ? props.image : constants.noImg
})
</script>
